import { useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';
import { isLocalOnly, setLocalOnly } from '@/lib/localOnly';
import { getCachedApiBase, discoverApiBaseOnce } from '@/lib/runtimeApiDiscovery';

export default function LocalOnlyBanner() {
  const [visible, setVisible] = useState<boolean>(isLocalOnly());
  const [apiBase, setApiBase] = useState<string | null>(getCachedApiBase());
  const [probing, setProbing] = useState(false);

  useEffect(() => {
    const onChange = (ev: any) => setVisible(Boolean(ev?.detail?.localOnly));
    window.addEventListener('pwa:local-only-changed', onChange as EventListener);
    return () => window.removeEventListener('pwa:local-only-changed', onChange as EventListener);
  }, []);

  if (!visible) return null;

  return (
    <div className="fixed top-2 left-1/2 -translate-x-1/2 z-60">
      <div className="bg-yellow-200 text-yellow-900 px-4 py-2 rounded shadow flex items-center gap-3">
        <div className="text-sm">Local-only mode: server persistence unavailable. Invite state is stored locally only.</div>
        <div className="flex items-center gap-2">
          <div className="text-xs text-muted-foreground">API base: <strong>{apiBase || '(unknown)'}</strong></div>
          <Button variant="outline" size="sm" onClick={() => { setLocalOnly(false); setVisible(false); }}>Dismiss</Button>
          <Button variant="ghost" size="sm" onClick={async () => {
            setProbing(true);
            try {
              const base = await discoverApiBaseOnce();
              setApiBase(base);
              if (base) {
                // clear local-only once we have a backend
                try { setLocalOnly(false); setVisible(false); } catch {}
              }
            } catch (e) {
              // ignore
            } finally { setProbing(false); }
          }}>
            {probing ? 'Probing...' : 'Check API'}
          </Button>
        </div>
      </div>
    </div>
  );
}
